module.exports = __webpack_public_path__ + "static/img/lucky_boxes_txt.39bee4e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/lucky_boxes_txt.png
// module id = 5BBX
// module chunks = 1